import {logTypes} from './constants';
import {getConfigItem, configConstants, observeConfigItem} from '@servicenow/ui-config';
const {LOGGING_ENABLED, LOGGING_LEVELS} = configConstants;

let globalLoggingEnabled = getConfigItem(LOGGING_ENABLED);
let globalLoggingLevels = getConfigItem(LOGGING_LEVELS);

const observer = (path, value) => {
	switch (path) {
		case LOGGING_ENABLED:
			globalLoggingEnabled = value;
			break;
		case LOGGING_LEVELS:
			globalLoggingLevels = value;
			break;
	}
};

observeConfigItem(LOGGING_ENABLED, observer);
observeConfigItem(LOGGING_LEVELS, observer);

export default function shouldLog(logContext, options) {
	const {always, level: logType} = options;
	if (always) return true;

	if (!logTypes.includes(logType)) return false;

	const {nowLoggingLevels} = logContext;

	if (nowLoggingLevels === true || nowLoggingLevels === false) return nowLoggingLevels;

	if (Array.isArray(nowLoggingLevels)) return nowLoggingLevels.includes(logType);

	if (globalLoggingLevels === true || globalLoggingLevels === false) return globalLoggingLevels;

	if (Array.isArray(globalLoggingLevels)) return globalLoggingLevels.includes(logType);

	return !!globalLoggingEnabled;
}
